// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1Q14TZt_","content":"HijxekWL","speedDivMain":"tSof16wX","toHide":"_1auE2ysK","closeBar":"_3NNW13oe","speedDiv":"_1zAO2pxv","greyLine":"iklNIuWR","calendar-container":"_3TnA1fmM","workouts-container":"Ph0fXIjT","workout-content":"_2Rirx4D9"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/DailyWorkoutPage/DailyWorkoutPage.styl
// module id = 527
// module chunks = 0